import { FC, useState } from "react";
import { useTabContext } from "../../context/tabs/TabContext";
import PlatformClubs from "./PlatformClubs";

const Platform: FC = () => {
  const [tab, setTab] = useState<string>("");

  const changeTab = (tab: string): void => {
    setTab(tab);
    console.log(tab);
  };

  return (
    <div>
      <useTabContext.Provider
        value={{
          tab,
          changeTab,
        }}
      >
        <PlatformClubs />
      </useTabContext.Provider>
    </div>
  );
};

export default Platform;
